export default function ResponsiveGraphWrapper(props) {
  return (
    <div
      css={{
        height: 0,
        paddingTop: '56.25%',
        position: 'relative',

        '> *': {
          position: 'absolute',
          top: 0,
          left: 0,
        },
      }}
      {...props}
    />
  )
}
